import {Component} from "@angular/core";

@Component({
  selector: 'app-new-payment-ui',
  templateUrl: './new-payment-ui.component.html',
  styleUrls: ['./new-payment-ui.component.css']
})
export class NewPaymentUiComponent{}



// WEBPACK FOOTER //
// ./src/app/new-payment-ui/new-payment-ui.component.ts